var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-4"},[_c('v-btn',{staticClass:"ma-4",attrs:{"color":"red","outlined":""},on:{"click":_vm.onRemove}},[_vm._v("Xóa lớp bán trú")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }